app.factory('freeGameService', ['$q', '$timeout', '$http', function ($q, $timeout, $http) {
	var service = this;

	service.ready = false;
	service.exercises = [];

	function indexify(collection, forEachFunc) {
		for (var i = 0; i < collection.length; i++) {
			var item = collection[i];
			item.index = i;
			if (forEachFunc) {
				forEachFunc(item);
			}
		}
	}

	service.setupFreeGame = function() {
		if (service.ready) {
			return $q(function(resolve, reject) {
				resolve();
			});
		}

		return $q(function(resolve, reject) {
			$http.get('/api/freegame').then(function(response) {
				var game = response.data;
				var exercises = angular.copy(game.exercises);
				indexify(exercises, function(exercise) {
					indexify(exercise.questions, function(question) {
						indexify(question.answers);
					});
					indexify(exercise.evaluationQuestions, function(question) {
						indexify(question.answers);
					});
				});
				service.exercises = exercises;
				service.ready = true;
				resolve();
			}, function() {
				reject();
			});
		});
	}

	service.exerciseWithIndex = function(exerciseIndex) {
		for (var i = 0; i < service.exercises.length; i++) {
			var exercise = service.exercises[i];
			if (exercise.index === exerciseIndex) {
				return exercise;
			}
		}
		return undefined;
	}

	service.lookupQuestion = function(exerciseIndex, questionIndex) {
		var exercise = service.exerciseWithIndex(exerciseIndex);
		for (var i = 0; i < exercise.questions.length; i++) {
			var question = exercise.questions[i];
			if (question.index === questionIndex) {
				return question;
			}
		}
		return undefined;
	}

	return service;
}]);
